import { useHebcal } from '../../hooks/useHebcal'
import { useLanguage } from '../../i18n/LanguageContext'

export function ShabbatHoliday() {
  const { shabbat, holidays, loading } = useHebcal()
  const { t, lang } = useLanguage()

  if (loading) return null

  const candleLightingStr = shabbat.candleLighting
    ? new Intl.DateTimeFormat(lang === 'he' ? 'he-IL' : 'en-IL', {
        weekday: 'long',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Asia/Jerusalem',
      }).format(shabbat.candleLighting)
    : null

  return (
    <div>
      {candleLightingStr && (
        <div className="bg-emerald-500/10 rounded-lg p-3 mb-3">
          <p className="text-emerald-400 font-bold text-sm">{t('shabbat.shabbatCheap') as string}</p>
          <p className="text-slate-400 text-xs mt-1">
            {t('shabbat.candleLighting') as string} {candleLightingStr}
          </p>
        </div>
      )}

      {holidays.length > 0 && (
        <div className="space-y-2">
          <p className="text-slate-400 text-xs">{t('shabbat.upcomingHolidays') as string}</p>
          {holidays.slice(0, 3).map((h, i) => (
            <div key={i} className="flex items-center justify-between bg-white/5 rounded-lg px-3 py-2">
              <span className="text-sm text-white">{h.title}</span>
              <span className="text-xs text-slate-500">
                {new Date(h.date).toLocaleDateString(lang === 'he' ? 'he-IL' : 'en-IL')}
              </span>
            </div>
          ))}
        </div>
      )}

      {!candleLightingStr && holidays.length === 0 && (
        <p className="text-slate-500 text-sm">{t('shabbat.noInfo') as string}</p>
      )}
    </div>
  )
}

export function getShabbatPreview(candleLighting: Date | null, lang: 'he' | 'en'): string | undefined {
  if (!candleLighting) return undefined
  const str = new Intl.DateTimeFormat(lang === 'he' ? 'he-IL' : 'en-IL', {
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Jerusalem',
  }).format(candleLighting)
  return lang === 'he' ? `כניסת שבת: ${str}` : `Shabbat entrance: ${str}`
}
